'use strict';

angular.module('dash.contourPreview', [])

.controller('ContourPreviewController', require('./ContourPreviewController'))
.directive('contourPreview', require('./ContourPreviewDirective'))

//Flux Actions and Store
.factory('ContourPreviewActions', require('./ContourPreviewActions'))
.factory('ContourPreviewStore', require('./ContourPreviewStore'))

.service('ContourPreviewService', require('./ContourPreviewService'))

//Bind store to actions through init method
.run(['ContourPreviewStore', (ContourPreviewStore) => {
  ContourPreviewStore.init();
}]);



// WEBPACK FOOTER //
// ./src/app/shared/contourPreview/index.js